module.exports = __webpack_public_path__ + "img/layout_right_icon.7a3c01a0.svg";